import React from 'react'

export default function Pagination({ currentData, setData, setLoading, xhrAdapter }) {

const nextDisabled = currentData && currentData.hasNextPage;
const prevDisabled = currentData && currentData.hasPrevPage;
const getPaginatedData = async (type) => {
    setLoading(true);
    const nextPage = currentData.hasNextPage ? currentData.nextPage : null;
    const prevPage = currentData.hasPrevPage ? currentData.prevPage : null;
    const page = type === 'prev' ? prevPage : nextPage;
    if (page !== null) {
        await xhrAdapter().then((res) => {
            if (res.status === 200) {
                const newData = res.data;
                setData(newData)
            }
        })
    }
    setLoading(false);
}

  return (
    <>
    <div className="mt-2 flex justify-between items-center w-full">
              <button disabled={prevDisabled} onClick={() => getPaginatedData('prev')} className={`rounded-lg py-1 font-semibold text-sm flex justify-center px-6 bg-white border-2 border-gray-600  text-gray-800 ${currentData && currentData.hasNextPage ? 'hover:border-blue-800 hover:text-blue-800' : ''}`}>
            <span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
                  </svg>
            </span>
            <span>Prev</span>
        </button>
              <button disabled={nextDisabled} onClick={() => getPaginatedData('next')} className={`rounded-lg py-1 font-semibold text-sm flex justify-center px-6 bg-white border-2 border-gray-600  text-gray-800 ${currentData && currentData.hasNextPage ? 'hover:border-blue-800 hover:text-blue-800' : ''}`}>
            <span>Next</span>
            <span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" />
                  </svg>
            </span>
        </button>
    </div>
    </>
  )
}
